import { FunctionComponent, useState, useContext, useEffect } from 'react';
import getByPath from 'Tools/getByPath';
import { useFormContext } from 'react-hook-form';
import { counterTrigger } from 'Tools/counters';
import formatDate from 'Tools/formatDate';
import addZero from 'Tools/addZero';
import { PET_NAMES, DOG } from 'Tools/pets';
import { AddPetContext } from '../../AddPet';
import * as s from './SecondStep.css';
import PetsInput from '../PetsInput';
import PetsSelect from '../PetsSelect';
import { AddPetField } from '../../AddPet.types';
const getKindByValue = (val: number) => {
    switch (val) {
        case 1:
            return 'kind_dog';
        case 2:
            return 'kind_cat';
    }
};
const SecondStep: FunctionComponent = () => {
    const { getValues, register, errors, clearErrors } = useFormContext();
    const masks = [
        {
            mask: '00/0000',
            lazy: true,
        },
        {
            mask: '00/00/0000',
            lazy: true,
        },
    ];
    const birthDateRegExp = /(^(0[1-9]|[12][0-9]|3[01])[\/](0[1-9]|1[012])[\/](19|20)\d\d$)|(^(0[1-9]|1[012])[\/](19|20)\d\d$)/;
    const [firstInputState, setFirstInputState] = useState<boolean>(false);
    const [secondInputState, setSecondInputState] = useState<boolean>(false);
    const resetSelectsStates = () => {
        setFirstInputState(false);
        setSecondInputState(false);
    };
    const handleFirstSelectState = (clear: boolean) => {
        if (clear) {
            resetSelectsStates();
        }
        else {
            setFirstInputState(!firstInputState);
            setSecondInputState(false);
        }
    };
    const handleSecondSelectState = (clear: boolean) => {
        if (clear) {
            resetSelectsStates();
        }
        else {
            setFirstInputState(false);
            setSecondInputState(!secondInputState);
        }
    };
    const addPetContext = useContext(AddPetContext);
    useEffect(() => {
        counterTrigger('addPetWindowSecondStep');
        if (addPetContext?.isEdit)
            register({
                name: 'pet',
                type: 'custom',
                value: getByPath('remote.form.fields.pet.value', addPetContext),
            }, { required: true });
    }, []);
    const kind = getByPath(`form.fields.${getKindByValue(getValues('pet'))}`, addPetContext?.remote) as AddPetField;
    const weight = getByPath('form.fields.weight', addPetContext?.remote) as AddPetField;
    const nickValue = getByPath('form.fields.nick.value', addPetContext?.remote);
    const birthDateValue = getByPath('form.fields.birth_date.value', addPetContext?.remote);
    const petType = PET_NAMES[getValues('pet') as keyof typeof PET_NAMES];
    const onButtonClick = (): void => {
        addPetContext?.setStep((prevStep) => prevStep + 1);
        counterTrigger('addPetWindowDeletePet');
    };
    const getDateString = (date: Date, divider: string = '/'): string => {
        const month = addZero(date.getMonth() + 1);
        const day = addZero(date.getDate());
        return `${date.getFullYear()}${divider}${month}${divider}${day}`;
    };
    const validate = (value: string): boolean | string => {
        const currentDate = new Date();
        let parts = value.split('/');
        let formatedDate = formatDate(value);
        if (parts.length === 2) {
            parts = ['01', ...parts];
            formatedDate = formatDate(`01/${value}`);
        }
        const [d, m, y] = parts;
        const formatedDateString = `${y}/${m}/${d}`;
        const date = new Date(formatedDate[0], formatedDate[1], formatedDate[2]);
        const diff = new Date(currentDate.getTime() - date.getTime()).getFullYear() - 1970;
        const message = currentDate < date
            ? 'Нельзя указать дату в будущем'
            : 'Введите корректную дату рождения.';
        return (0 <= diff && formatedDateString === getDateString(date)) || message;
    };
    if (errors.user_email) {
        clearErrors('user_email');
    }
    if (errors.user_phone) {
        clearErrors('user_phone');
    }
    return (<section className="ThirdStepWrapper">
      <div className={s.rootSection}>
        <PetsInput label="Кличка" placeholder="Введите кличку питомца" name="nick" triggerOnChange required defaultValue={nickValue} dataQaDetail="NickInput"></PetsInput>
        {kind && (<PetsSelect name={kind.name} options={kind.items
                .filter((i) => i[0])
                .map((item) => ({ value: item[0], label: item[1] }))} defaultValue={kind.value} withSearch alwaysShowAllOptions label="Порода" placeholder="Выберите породу" handleSelectState={handleFirstSelectState} active={firstInputState} dataQa="KindSelect"></PetsSelect>)}
        <PetsInput label="Дата рождения" name="birth_date" defaultValue={birthDateValue} triggerOnChange mask={masks as unknown as IMask.MaskedDynamic} required placeholder={'ДД/ММ/ГГГГ или ММ/ГГГГ'} pattern={{
            value: birthDateRegExp,
            message: 'Заполните дату в формате ДД/ММ/ГГГГ или ММ/ГГГГ',
        }} inputHint="Если вы не помните день рождения своего питомца, укажите месяц и год (ММ/ГГГГ)" validate={{ validate }} dataQaDetail="BirthDateInput"></PetsInput>
        {petType === DOG && weight && (<PetsSelect name={weight.name} options={weight.items
                .filter((i) => i[0])
                .map((item) => ({ value: item[0], label: item[1] }))} defaultValue={weight.value} withSearch alwaysShowAllOptions label="Какого размера ваш питомец?" required placeholder="Выберите размер" handleSelectState={handleSecondSelectState} active={secondInputState}></PetsSelect>)}
        {addPetContext?.isEdit && (<a className={s.deletePetLink} onClick={onButtonClick}>
            Удалить питомца
          </a>)}
      </div>
    </section>);
};
export default SecondStep;
